import { useRef, useState } from 'react'
import { toast } from 'sonner'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { ClientesAgradaStatsCards } from '@/components/ClientesAgrada/ClientesAgradaStatsCards'
import { ClientesAgradaTable } from '@/components/ClientesAgrada/ClientesAgradaTable'
import { ClientesAgradaTopbar } from '@/components/ClientesAgrada/ClientesAgradaTopbar'
import { useClientesAgradaPage } from '@/hooks/useClientesAgradaPage'
import { clientesService } from '@/services/clientesService'
import { useAuthStore } from '@/stores/authStore'

export default function ClientesAgrada() {
  const { filter, setFilter, search, setSearch, clientes, totalItems, loading, reload } =
    useClientesAgradaPage()

  const role = (useAuthStore((s) => s.user?.role) ?? '').toLowerCase()
  const canImport = ['admin', 'financeiro'].includes(role)
  const fileRef = useRef<HTMLInputElement>(null)
  const [importing, setImporting] = useState(false)

  const handleImport = async (file: File) => {
    setImporting(true)
    try {
      const result = await clientesService.importCsv(file)
      toast.success(
        `Importação: ${result.created} criados, ${result.updated} atualizados, ${result.skipped} ignorados`,
      )
      if (result.errors.length > 0) {
        toast.warning(`${result.errors.length} linha(s) com erro`)
      }
      await reload()
    } catch {
      toast.error('Falha ao importar CSV')
    } finally {
      setImporting(false)
    }
  }

  return (
    <DashboardLayout title='Clientes Agrada'>
      <ClientesAgradaTopbar
        filter={filter}
        setFilter={setFilter}
        search={search}
        setSearch={setSearch}
        loading={loading}
        onReload={() => void reload()}
        canImport={canImport}
        importing={importing}
        onImportClick={() => fileRef.current?.click()}
      />

      {canImport && (
        <input
          ref={fileRef}
          type='file'
          accept='.csv,text/csv'
          className='hidden'
          onChange={(e) => {
            const file = e.target.files?.[0]
            if (file) void handleImport(file)
            e.target.value = ''
          }}
        />
      )}

      {!loading && <ClientesAgradaStatsCards totalItems={totalItems} clientes={clientes} />}

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : (
        <ClientesAgradaTable clientes={clientes} />
      )}
    </DashboardLayout>
  )
}
